import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function NConsejosParaPage() {
  return (
    <>
      <Blogs
        title={"6 consejos para manejar tus finanzas"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                Si aún no sabes cómo debes organizar tus finanzas personales
                tenemos un artículo que seguro te ayudará, aquí te contamos 6
                consejos que puedes aplicar para manejar tus finanzas.
              </p>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Hola astronauta, bienvenido al mundo Galilea, si quieres mejorar
                el manejo de tus finanzas personales pon en práctica los
                siguientes consejos:
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/registrarse" className="text-purple hover:underline">
                Si quieres solicitar tu crédito en Galilea da clic aquí.
              </a>
            </span>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Identifica la totalidad de tus ingresos
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Identificar de dónde provienen tus ingresos y cuál es su
                totalidad te ayudará a mantenerte organizado, así sabrás con
                cuánto dinero cuentas para el mes.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Crea una lista con todos tus gastos
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Haz una lista de todos tus gastos para darte cuenta en qué estás
                gastando tu dinero y cuánto estás gastando. Puedes hacerlo en
                papel, en un Excel o en aplicaciones móviles para anotar tus
                gastos, elige el método más cómodo para ti.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Divide tus gastos en fijos y variables
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Los gastos fijos son aquellos que te permiten sobrevivir, tales
                como, los servicios, el arriendo, el transporte diario, el
                mercado, etc.
              </p>
              <p className="pt-10">
                Por otro lado, los gastos variables son los que se relacionan
                con tu estilo de vida, las salidas, los viajes, la ropa, entre
                otros. Diferenciar unos y otros te ayudará a saber en qué
                actividades puedes evitar gastar dinero.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Elimina la mayor cantidad de gastos variables posibles
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Los gastos variables no son necesarios para sobrevivir, así que
                entre más logres reducirlos tendrás mayor capacidad financiera
                para ahorrar o invertir en algo que te proporcione una ventaja
                en el futuro.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Controla tus créditos y mantén una buena relación con las
                compañías de financiamiento
              </span>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Tener deudas en sí no es algo malo siempre y cuando su finalidad
                sea para tu crecimiento personal y financiero, como una deuda
                para invertir en tu negocio, o para aprender una nueva habilidad
                que en el futuro te permita aumentar tus ingresos, o para hacer
                realidad un sueño muy anhelado, como también, crear un historial
                crediticio que te permita obtener mejores condiciones a futuro.
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/registrarse" className="text-purple hover:underline">
                Mejora tu puntaje crediticio con un crédito en Galilea, haz clic
                aquí si quieres conocer más.
              </a>
            </span>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Todo dentro de tus capacidades y sin sobrepasar tu nivel de
                ingresos las deudas te permitirán acceder a eso que siempre has
                soñado y aumentar tu nivel de ingresos si te vuelves un experto
                usandolas.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Crea un fondo de emergencias
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Si bien no es posible saber cuándo tendremos una emergencia
                podemos anticiparnos a ellas teniendo un fondo de emergencia que
                no debes tocar a menos que sea necesario, esto podría evitarte
                problemas financieros en el futuro.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">Ahorra e Invierte</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Para que logres alcanzar tus metas, ten el respaldo de un
                ahorro que te permita disfrutar en el futuro, por eso te
                recomendamos que ahorres de manera mensual una cantidad fija,
                también puedes plantearte poner a trabajar tu dinero invirtiendo
                en cualquiera de los diferentes planes que se tienen en el
                mercado.
              </p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">Algo muy importante acerca de la inversión</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Si te interesa invertir pero no tienes dinero, o no sabes en qué, la respuesta es muy clara. Invierte en ti, no hay inversión más garantizada y más rentable que invertir y aumentar tus habilidades financieras, por eso, hacer un curso intensivo en internet, o comprar un libro de finanzas será la mejor decisión de inversión, así como unirse a un grupo en Facebook de personas que estén interesadas en sus finanzas te ayudará a aprender a generar ingresos y luego, a invertirlos.
              </p>
            </div>
          </>
        }
        enlace1={
          <a
            href="/blog/como-mejorar-mi-puntaje-en-datacredito"
            className="text-purple hover:underline"
          >
            ¿Cómo mejorar mi puntaje de crédito?
          </a>
        }
        enlace2={
          <a href="/blog/como-construir-historial-crediticio" className="text-purple hover:underline">
            Cómo construir historial crediticio
          </a>
        }
        enlace3={
          <a href="#" className="text-purple hover:underline">
            Apps para controlar tus finanzas personales
          </a>
        }
      />
    </>
  );
}
